import { useContext } from 'react';
import { logError } from '@/utils/logHandling';
import { DialogContext } from '@/components/ui/shared/Dialog';

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    logError('DialogContext not found in the tree-nodes');
    throw new Error('DialogContext not found in the tree-nodes');
  }
  return {
    showDialog: context.showDialog,
    removeDialog: context.removeDialog,
    removeAllDialogs: context.removeAllDialogs,
    updateDialog: context.updateDialog,
    openDialogIds: context.openDialogIds,
  };
};
